import { Component } from '@theme/component';



if (!customElements.get('product-variant-options-component')) {
  /**
 * Web component for product variant option selectors
 * (radio button groups loaded from `product.metafields.custom.variant_options`).
 *
 * Renders a group of `<fieldset>` elements, each containing a set of radio
 * inputs. When a radio is selected, the matching label text is updated, the
 * associated hidden input (form field) is updated, and a
 * `theme.events.variantOptionsChange` event is dispatched on `document`.
 *
 * @extends {Component}
 */
  class ProductVariantOptions extends Component {
    /**
     * Handles 'change' events on the variant option radio inputs (delegated
     * from the host element via the `on:change` attribute).
     *
     * @param {Event} event - The change event from a radio input.
     */
    onVariantChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

      const controlId = input.dataset.control;
      if (!controlId) return;

      const { value } = input;

      // Update the label text inside the same fieldset
      const labelValue = input
        .closest('.option-selector')
        ?.querySelector('.option-selector__label-value');
      if (labelValue) labelValue.textContent = value;

      // Update the value of the associated hidden input
      const hiddenInput = document.getElementById(controlId);
      if (hiddenInput instanceof HTMLInputElement) hiddenInput.value = value;
      document.dispatchEvent(
        new CustomEvent(theme.events.variantOptionsChange, {
          detail: { controlId, value }
        })
      );
    };
  }
  customElements.define('product-variant-options-component', ProductVariantOptions);
}
